import { Pipe, PipeTransform, inject } from '@angular/core';
import { GridFormatService } from "../services";

@Pipe({ name: "gridNumber" })
export class GridNumberPipe implements PipeTransform
{
    private $gridFormatService = inject(GridFormatService);


    transform(value: any, column: any, percent: boolean): string
    {
        if(column.DataType === "nonDelineatedNumber")
        {
            return this.$gridFormatService.nonDelineatedNumberFormatter(value, column);
        }
        else
        {
            return this.$gridFormatService.numberFormatter(value, column, percent);
        }
    }
}
